import React, { Fragment } from "react";
import { useState, useEffect, useRef } from 'react';
import { Dialog, Popover, Transition } from '@headlessui/react';
import Bars3Icon from '../icons/Bars3Icon';
import XMarkIcon from '../icons/XMarkIcon';
import MagnifyingGlassIcon from "../icons/MagnifyingGlass";
import EventsIcon from "../icons/EventsIcon";
import NavLogo from "./NavLogo"
import { useLocation, useNavigate, useSearchParams } from "react-router-dom";
import SelectForumModal from "../forum/SelectForumModal";
import UserDropDown from "./UserDropDown";
import InviteUserModal from "../leaderboard/InviteUserModal";
import { getSessionData } from "../../utils/auth";
import { logout } from "../../core/auth";
import NavUserAvatar from "./NavUserAvatar";
import PowerIcon from "../icons/PowerIcon";
import MobileMenuSearchModal from "./MobileMenuSearchModal";
import LoginAlertModal from "../auth/LoginAlertModal"
import { getJobsBudgesLastTime, getCommunityBudges, getEventsBudgesLastTime } from "../../core/communities";
import { getUsersChatsList } from "../../core/chat";
import { getSupportBadges } from "../../core/support";
import { CHAT_UNREAD_CHANGED, notifyChatUnreadChanged } from "../../utils/chatUnread";
import { ACTIVITIES_UNREAD_CHANGED } from "../../utils/eventsUnread";
import { JOBS_UNREAD_CHANGED } from "../../utils/jobsUnread";
import { SUPPORT_UNREAD_CHANGED } from "../../utils/supportUnread";
import {
    POST_VIEWED_CHANGED,
    countCommunityBadgePosts,
    removePostFromCommunityBadges,
} from "../../utils/postsViewed";
import { Utils } from "../../utils";
import { useSocket } from "../../utils/SocketProvider";
import BriefCase from "../icons/BriefCase";
import Globe from "../icons/Globe";
import ChatsIcon from "../icons/Chats";
import AiIcon from "../icons/AiIcon";
import CommunityRequestIcon from "../icons/Community";
import StarIcon from "../icons/Star";
import EnvelopeOpen from "../icons/EnvelopeOpen";
import EnvelopeClosedSolid from "../icons/EnvelopeClosedSolid";
import Ad from "../icons/Ad";
import SpeakerWave from "../icons/SpeakerWave";
import { useAuth } from '../../utils/AuthProvider';
import WefayoAIChatInterface from "../wefayoAI/ChatInterface";
import AsideCommunities from "../aside/AsideCommunities";
import LeaderBoardIcon from "../icons/LeaderBoardIcon";
import CommunicationBoardInterface from "../CommunicationBoardInterface";
import BlueEnvelopeProgramInterface from "../BlueEnvelopeProgramInterface";

function classNames(...classes) {
    return classes.filter(Boolean).join(' ')
}

const NavHeader = ({
    currentPage = "communities",
    mobileChatClasses = "",
    communities = [],
    handleClickRequestCommunity = () => { },
    onSelectCommunity = () => { },
    setCurrentCommunity = () => { },
    selectedCommunityId = null,
    openCommunitiesModalProxy = () => { },
    openMenuContextProxy = () => { } }) => {

    const { logoff } = useAuth();

    let loggedInUser = getSessionData();
    const { socket } = useSocket();

    const [mobileMenuOpen, setMobileMenuOpen] = useState(false);
    const [openMenuContext, setOpenMenuContext] = useState("header");
    const [isWefayoAIChatOpen, setIsWefayoAIChatOpen] = useState(false);
    const [isCommunicationBoardOpen, setIsCommunicationBoardOpen] = useState(false);
    const [isBlueEnvelopeProgramOpen, setIsBlueEnvelopeProgramOpen] = useState(false);
    let navigation = [
        { name: 'Communities', href: '/', active: ["communities", "community", "forum", "post"].indexOf(currentPage) >= 0, className: "", id: "menu-link-communities", budgeCount: 0, icon: Globe },
        { name: 'Ask Wefayo AI', href: '/wefayo-ai', active: currentPage == "ai-chat", className: "md:px-3", id: "menu-link-ai-chat", budgeCount: 0, icon: AiIcon },
        { name: 'Jobs', href: '/jobs', active: currentPage == "jobs", className: "md:px-3", id: "menu-link-jobs", budgeCount: 0, icon: BriefCase },
        { name: 'Activities', href: '/events', active: currentPage == "events", className: "md:px-3", id: "menu-link-events", budgeCount: 0, icon: EventsIcon },
        { name: 'Chat', href: `/chat`, active: currentPage === "chat", className: "md:px-3", id: "menu-link-chat", budgeCount: 0, icon: ChatsIcon },
        { name: 'Communication Tools', href: `/communication-tools`, active: currentPage == "cb", id: "menu-link-cb", className: "px-0 md:px-3", icon: SpeakerWave }
    ];

    if (loggedInUser !== null) {
        //     navigation.push({
        //         name: 'Post a Job', href: `/jobs/add`, active: currentPage == "addjob", className: ""
        //     });
        // navigation.push({
        //     name: 'Community Request', href: `/community-request-form`, active: currentPage === "request", className: "", id: "menu-link-requests", budgeCount: 0, icon: CommunityRequestIcon
        // });
    }

    //{ name: 'About', href: '/about',  active: currentPage=="about"}

    const location = useLocation();
    const isRequest = location.pathname.indexOf("/community-request-form") == 0;
    const isPost = location.pathname.indexOf("/post/") > 0;
    const isForum = location.pathname.indexOf("/community/") == 0 && location.pathname.indexOf("/forum/") > 0 && isPost == false;

    const [isSelectForumModalOpen, setIsSelectForumModalOpen] = useState(false);
    const toggleSelectForumModal = () => {
        setIsSelectForumModalOpen(!isSelectForumModalOpen);
    };


    const navigate = useNavigate();
    const [searchParams, setSearchParams] = useSearchParams();
    let initialTermValue = "";
    if (location.pathname.indexOf("/search") == 0) {
        initialTermValue = searchParams.get("term");
    }

    const [searchTerm, setSearchTerm] = useState(initialTermValue);
    const handleChange = (event) => {
        setSearchTerm(event.target.value);
    };
    const handleKeyDown = (event) => {
        if (event.key === 'Enter') {
            navigate(`/search?term=${searchTerm}`);
        }
    };



    const [isInviteUserModalOpen, setIsInviteUserModalOpen] = useState(false);
    const toggleInviteUserModal = () => {
        setIsInviteUserModalOpen(!isInviteUserModalOpen);
    };

    useEffect(() => {
        const handleOpenInviteModal = () => setIsInviteUserModalOpen(true);
        window.addEventListener('wefayo-open-invite-modal', handleOpenInviteModal);
        return () => window.removeEventListener('wefayo-open-invite-modal', handleOpenInviteModal);
    }, []);

    const goToLogin = () => {
        toggleLoginAlertModalModal();
        // navigate(`/login`);
    }


    const [isMobileSearchModalOpen, setIsMobileSearchModalOpen] = useState(false);
    const toggleMobileSearchModalModal = () => {
        setIsMobileSearchModalOpen(!isMobileSearchModalOpen);
    };

    const [isLoading, setIsLoading] = useState(false);
    const handleSubmit = async (e) => {
        e.preventDefault();
        setIsLoading(true);
        logout();
        logoff();
        setIsLoading(false);
        navigate("/");
    };

    const [isLoginAlertModalOpen, setIsLoginAlertModalOpen] = useState(false);
    const toggleLoginAlertModalModal = () => {
        setIsLoginAlertModalOpen(!isLoginAlertModalOpen);
    };

    // if (loggedInUser !== null && loggedInUser.role === "admin") {
    //     navigation.push({
    //         name: 'PPs', href: `/forumads`, active: currentPage == "forumads", className: "px-3", icon: Ad
    //     });
    // }



    const [navigationObjects, setNavigationObjects] = useState(navigation);
    // Raw { forumId: [postId,...] } map. Reused below to render the badge on
    // each forum/community row inside the mobile communities modal so users
    // can tell which forum is responsible for the nav-icon pill.
    const [communityBudgesMap, setCommunityBudgesMap] = useState({});
    const [supportBudgeCount, setSupportBudgeCount] = useState(0);
    const mobileNavObjActivitiesPage = {
        name: 'Leader Boards',
        href: '/leader-boards',
        active: currentPage == "leaderBoard",
        className: "px-3",
        id: "menu-link-leader-board",
        budgeCount: 0,
        icon: LeaderBoardIcon
    };
    const mobileNavBlueEnvelopeProgramPage = {
        name: 'Blue Envelope Program',
        href: '/blue-envelope-program',
        active: currentPage == "blue-envelope-program",
        className: "md:px-3",
        id: "menu-link-blue-envelope-program",
        budgeCount: 0,
        icon: () => { return <span className="relative text-[#39bdf8]"><EnvelopeClosedSolid fillColor="#39bdf8" /></span> }
    };
    const fetchCountsData = async (isMountedRef, options = {}) => {
        const { skipEvents = false } = options;
        try {
            if (loggedInUser === null) {
                setCommunityBudgesMap({});
                setSupportBudgeCount(0);
                setNavigationObjects((prev) => prev.map((navOb) => ({ ...navOb, budgeCount: 0 })));
                return;
            }

            const chatListPromise = getUsersChatsList('');
            const badgePromises = [
                getJobsBudgesLastTime(),
                getCommunityBudges(),
                chatListPromise,
                getSupportBadges(),
            ];
            if (!skipEvents) {
                badgePromises.push(getEventsBudgesLastTime());
            }
            const settled = await Promise.allSettled(badgePromises);
            const jobsBadgesResult = settled[0];
            const communityResult = settled[1];
            const chatResult = settled[2];
            const supportResult = settled[3];
            const eventsResult = skipEvents ? null : settled[4];

            if (isMountedRef && isMountedRef.current === false) {
                return;
            }

            let newJobsCount = 0;
            if (jobsBadgesResult.status === 'fulfilled' && jobsBadgesResult.value && typeof jobsBadgesResult.value === 'object') {
                const parsed = Number(jobsBadgesResult.value.new_jobs_count);
                if (Number.isFinite(parsed) && parsed > 0) {
                    newJobsCount = Math.floor(parsed);
                }
            }

            let newPostsCount = 0;
            let nextBudgesMap = {};
            if (communityResult.status === 'fulfilled' && communityResult.value && typeof communityResult.value === 'object') {
                const communityBudges = communityResult.value;
                for (const key in communityBudges) {
                    if (Object.hasOwnProperty.call(communityBudges, key) && Array.isArray(communityBudges[key])) {
                        nextBudgesMap[key] = communityBudges[key];
                        newPostsCount += communityBudges[key].length;
                    }
                }
            }
            setCommunityBudgesMap(nextBudgesMap);

            let unreadChatCount = 0;
            if (chatResult.status === 'fulfilled' && chatResult.value && !Array.isArray(chatResult.value)) {
                const raw = chatResult.value.un_seen_count;
                const parsed = Number(raw);
                if (Number.isFinite(parsed) && parsed > 0) {
                    unreadChatCount = Math.floor(parsed);
                }
            }

            let unreadSupportCount = 0;
            if (supportResult.status === 'fulfilled' && supportResult.value && typeof supportResult.value === 'object') {
                const parsed = Number(supportResult.value.unseen_count);
                if (Number.isFinite(parsed) && parsed > 0) {
                    unreadSupportCount = Math.floor(parsed);
                }
            }
            setSupportBudgeCount(unreadSupportCount);

            let newEventsCount = null;
            if (!skipEvents && eventsResult && eventsResult.status === 'fulfilled' && eventsResult.value && typeof eventsResult.value === 'object') {
                const parsed = Number(eventsResult.value.new_events_count);
                if (Number.isFinite(parsed) && parsed >= 0) {
                    newEventsCount = Math.floor(parsed);
                }
            }

            // Functional setter avoids relying on the closed-over
            // `navigationObjects` value at the time the effect ran.
            setNavigationObjects((prev) => prev.map((navOb) => {
                if (navOb.name === "Communities") {
                    return { ...navOb, budgeCount: newPostsCount };
                }
                if (navOb.name === "Jobs") {
                    return { ...navOb, budgeCount: newJobsCount };
                }
                if (navOb.name === "Activities" && newEventsCount !== null) {
                    return { ...navOb, budgeCount: newEventsCount };
                }
                if (navOb.name === "Chat") {
                    return { ...navOb, budgeCount: unreadChatCount };
                }
                return navOb;
            }));
        } catch (_err) {
            // Last-resort guard: never let a badge fetch break the header.
        }
    };


    const skipPathnameBadgeFetchRef = useRef(true);

    useEffect(() => {
        if (loggedInUser?._id) {
            skipPathnameBadgeFetchRef.current = true;
        }
    }, [loggedInUser?._id ?? null]);

    useEffect(() => {
        const isMountedRef = { current: true };
        fetchCountsData(isMountedRef);
        openCommunitiesModalProxy(setMobileMenuOpen);
        openMenuContextProxy(setOpenMenuContext);
        return () => {
            isMountedRef.current = false;
        };
        // Full badge refresh (including activities count) on login/logout only.
        // Activities updates between navigations use ACTIVITIES_UNREAD_CHANGED.
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [loggedInUser?._id ?? null]);

    useEffect(() => {
        if (loggedInUser === null) {
            return;
        }
        if (skipPathnameBadgeFetchRef.current) {
            skipPathnameBadgeFetchRef.current = false;
            return;
        }
        const isMountedRef = { current: true };
        fetchCountsData(isMountedRef, { skipEvents: true });
        return () => {
            isMountedRef.current = false;
        };
        // Re-run on route change so community/job/chat pills stay in sync
        // when the user visits a forum (asides). Activities count is event-driven.
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [location.pathname, loggedInUser?._id ?? null]);

    useEffect(() => {
        const handlePostViewed = (event) => {
            const postId = event?.detail?.postId;
            const forumId = event?.detail?.forumId;
            if (postId == null || postId === '' || forumId == null || forumId === '') {
                return;
            }
            setCommunityBudgesMap((prev) => {
                const next = removePostFromCommunityBadges(prev, forumId, postId);
                setNavigationObjects((navPrev) => navPrev.map((navOb) => {
                    if (navOb.name !== 'Communities') {
                        return navOb;
                    }
                    return { ...navOb, budgeCount: countCommunityBadgePosts(next) };
                }));
                return next;
            });
        };
        window.addEventListener(POST_VIEWED_CHANGED, handlePostViewed);
        return () => window.removeEventListener(POST_VIEWED_CHANGED, handlePostViewed);
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, []);

    useEffect(() => {
        if (!socket || loggedInUser === null) {
            return;
        }

        const handleIncomingChatMessage = async (incomingData) => {
            if (String(incomingData?.receiver_id) !== String(loggedInUser._id)) {
                return;
            }
            if (location.pathname.indexOf('/chat') === 0) {
                return;
            }
            const data = await getUsersChatsList('');
            if (data && !Array.isArray(data) && typeof data.un_seen_count === 'number') {
                notifyChatUnreadChanged(data.un_seen_count);
            }
        };

        socket.on('receiveMessage', handleIncomingChatMessage);
        return () => {
            socket.off('receiveMessage', handleIncomingChatMessage);
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [socket, loggedInUser?._id, location.pathname]);

    useEffect(() => {
        const isMountedRef = { current: true };
        const handleChatUnreadChanged = (event) => {
            const totalUnread = event?.detail?.totalUnread;
            if (typeof totalUnread === 'number' && Number.isFinite(totalUnread)) {
                setNavigationObjects((prev) => prev.map((navOb) => {
                    if (navOb.name === "Chat") {
                        return { ...navOb, budgeCount: Math.max(0, Math.floor(totalUnread)) };
                    }
                    return navOb;
                }));
            } else {
                fetchCountsData(isMountedRef);
            }
        };
        window.addEventListener(CHAT_UNREAD_CHANGED, handleChatUnreadChanged);
        return () => {
            isMountedRef.current = false;
            window.removeEventListener(CHAT_UNREAD_CHANGED, handleChatUnreadChanged);
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [loggedInUser?._id ?? null]);

    useEffect(() => {
        const isMountedRef = { current: true };
        const handleActivitiesUnreadChanged = (event) => {
            const totalUnread = event?.detail?.totalUnread;
            if (typeof totalUnread === 'number' && Number.isFinite(totalUnread)) {
                setNavigationObjects((prev) => prev.map((navOb) => {
                    if (navOb.name === "Activities") {
                        return { ...navOb, budgeCount: Math.max(0, Math.floor(totalUnread)) };
                    }
                    return navOb;
                }));
            } else {
                fetchCountsData(isMountedRef);
            }
        };
        const handleJobsUnreadChanged = (event) => {
            const totalUnread = event?.detail?.totalUnread;
            if (typeof totalUnread === 'number' && Number.isFinite(totalUnread)) {
                setNavigationObjects((prev) => prev.map((navOb) => {
                    if (navOb.name === "Jobs") {
                        return { ...navOb, budgeCount: Math.max(0, Math.floor(totalUnread)) };
                    }
                    return navOb;
                }));
            } else {
                fetchCountsData(isMountedRef);
            }
        };
        const handleSupportUnreadChanged = (event) => {
            const totalUnread = event?.detail?.totalUnread;
            if (typeof totalUnread === 'number' && Number.isFinite(totalUnread)) {
                setSupportBudgeCount(Math.max(0, Math.floor(totalUnread)));
            } else {
                fetchCountsData(isMountedRef);
            }
        };
        window.addEventListener(ACTIVITIES_UNREAD_CHANGED, handleActivitiesUnreadChanged);
        window.addEventListener(JOBS_UNREAD_CHANGED, handleJobsUnreadChanged);
        window.addEventListener(SUPPORT_UNREAD_CHANGED, handleSupportUnreadChanged);
        return () => {
            isMountedRef.current = false;
            window.removeEventListener(ACTIVITIES_UNREAD_CHANGED, handleActivitiesUnreadChanged);
            window.removeEventListener(JOBS_UNREAD_CHANGED, handleJobsUnreadChanged);
            window.removeEventListener(SUPPORT_UNREAD_CHANGED, handleSupportUnreadChanged);
        };
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [loggedInUser?._id ?? null]);

    const toggleWefayoAIChat = () => {
        setIsWefayoAIChatOpen(!isWefayoAIChatOpen);
    };

    const toggleCommunicationBoard = () => {
        setIsCommunicationBoardOpen(!isCommunicationBoardOpen);
    };

    const toggleBlueEnvelopeProgram = () => {
        setIsBlueEnvelopeProgramOpen(!isBlueEnvelopeProgramOpen);
    };

    const handleClickMobileMenuHamburger = () => {
        setMobileMenuOpen((s) => !mobileMenuOpen);
        setOpenMenuContext("header");
    }

    const closeMobileMenu = () => {
        setMobileMenuOpen((s) => false);
    }

    return (
        <header className="bg-primary-white fixed z-50 w-screen lg:min-h-[50px] flex flex-row items-center justify-between xl:justify-center">
            <LoginAlertModal message="Please log in to continue." isOpen={isLoginAlertModalOpen} closeFun={setIsLoginAlertModalOpen} />
            <WefayoAIChatInterface isModal={true} isOpen={isWefayoAIChatOpen} closeFun={setIsWefayoAIChatOpen} />
            <CommunicationBoardInterface isModal={true} isOpen={isCommunicationBoardOpen} closeFun={setIsCommunicationBoardOpen} />
            <BlueEnvelopeProgramInterface isModal={true} isOpen={isBlueEnvelopeProgramOpen} closeFun={setIsBlueEnvelopeProgramOpen} />
            <nav className="hidden lg:flex mx-auto xl:max-w-[1500px] flex-1 flex items-center  justify-between gap-x-10  md:gap-x-6   py-1 flex-grow  " aria-label="Global">
                <div className="w-40" >
                    <NavLogo />
                </div>
                <div className="flex flex-grow justify-start gap-x-8  md:gap-x-2">
                    <div className="flex  flex-row items-center gap-x-8 md:gap-x-6 ">
                        {navigationObjects.map((item) => {
                            let cls = `flex flex-col items-center relative text-xs whitespace-nowrap ${item.className} ${item.active ? 'accent-text-color active-menu-tab font-extrabold' : 'text-primary-gray-900 font-semibold'}`;
                            return (
                                <a key={item.name} href={item.href} className={cls} id={item.id}
                                    onClick={(e) => {
                                        if (item.name.toLowerCase() === 'chat' && loggedInUser === null) {
                                            e.preventDefault();
                                            toggleLoginAlertModalModal();
                                            return false;
                                        }

                                        if (item.id.toLowerCase() === 'menu-link-ai-chat' && loggedInUser === null) {
                                            e.preventDefault();
                                            toggleLoginAlertModalModal();
                                            return false;
                                        }

                                        if (item.id.toLowerCase() === 'menu-link-cb' && loggedInUser === null) {
                                            e.preventDefault();
                                            toggleLoginAlertModalModal();
                                            return false;
                                        }
                                    }}
                                >
                                    {item.icon &&
                                        <span className="relative">
                                            {React.createElement(item.icon)}
                                            {item?.budgeCount > 0 &&
                                                <span className={`bg-red-600 max-h-[15px] flex items-center absolute p-1 text-white  rounded-full  -right-[8px]  ${item.active ? '-top-[5px]' : '-top-2'}`} style={{ fontSize: "10px" }} >
                                                    {item?.budgeCount}
                                                </span>
                                            }
                                        </span>
                                    }
                                    <span>
                                        {item.name}
                                    </span>
                                </a>
                            )
                        })}

                        {/*
                            removes add a post from menu
                        <button role="button" 
                            onClick={loggedInUser !== null ? toggleSelectForumModal : goToLogin}
                            className={`text-sm leading-6  ${currentPage == "addpost" ? "accent-text-color active-menu-tab font-extrabold" : "text-primary-gray-900 font-semibold"}`}
                        >
                            Create a Post
                        </button> */}

                        {/* <button role="button"
                            onClick={loggedInUser !== null ? toggleInviteUserModal : goToLogin}
                            className="flex flex-col items-center relative text-xs text-primary-gray-900 font-semibold px-3"
                            id="menu-btn-invite"
                        >
                            <span className="relative">
                                <EnvelopeOpen />
                            </span>
                            <span>
                                Invite
                            </span>
                        </button> */}

                        <a
                            href="/blue-envelope-program"
                            className={`flex flex-col items-center relative text-xs whitespace-nowrap px-3 ${currentPage === 'blue-envelope-program' ? 'accent-text-color active-menu-tab font-extrabold' : 'text-primary-gray-900 font-semibold'}`}
                            id="menu-link-blue-envelope-program"
                            onClick={(e) => {
                                if (loggedInUser === null) {
                                    e.preventDefault();
                                    toggleLoginAlertModalModal();
                                    return false;
                                }
                            }}
                        >
                            <span className="relative text-[#39bdf8]">
                                <EnvelopeClosedSolid fillColor="#39bdf8" />
                            </span>
                            <span>
                                Blue Envelope Program
                            </span>
                        </a>

                    </div>

                    <div className="flex pl-4" id="menu-general-invite">
                        <label htmlFor="search" className="sr-only">
                            Search
                        </label>
                        <div className="relative text-gray-400 focus-within:text-gray-600" >
                            <div className="pointer-events-none absolute inset-y-0 left-0 flex items-center pl-3">
                                <MagnifyingGlassIcon className="h-5 w-5" aria-hidden="true" />
                            </div>
                            <input
                                id="search"
                                className="block w-[280px] rounded-full border-1 border-gray-200 bg-gray-300 py-0.5 pl-8 pr-3 text-gray mb-0 focus:border-purple-900 focus:ring-0 focus:ring-purple-900  sm:text-sm sm:leading-6"
                                placeholder="Search"
                                type="search"
                                name="search"
                                onKeyDown={handleKeyDown}
                                onChange={handleChange}
                                value={searchTerm}
                            />
                        </div>
                    </div>
                </div>
                {loggedInUser == null &&
                    <div className="flex items-center justify-end gap-x-6 md:gap-x-2 ">

                        <a href="/login" id="menu-link-login" className="hidden lg:block lg:text-sm lg:font-semibold lg:leading-6 lg:text-gray-900 whitespace-nowrap ">
                            Log In
                        </a>
                        <a
                            href="/register"
                            id="menu-link-signup"
                            className="rounded-sm bg-purple-900 px-3 py-1 text-sm font-semibold text-primary-white shadow-sm hover:bg-purple-800 whitespace-nowrap "
                        >
                            Sign Up
                        </a>

                    </div>
                }

                {loggedInUser != null &&
                    <UserDropDown user={loggedInUser} currentPage={currentPage} supportBudgeCount={supportBudgeCount} />
                }


            </nav>
            <SelectForumModal isOpen={isSelectForumModalOpen} closeFun={setIsSelectForumModalOpen} />
            <InviteUserModal isOpen={isInviteUserModalOpen} closeFun={setIsInviteUserModalOpen} />




            <div className={`-mr-1 flex justify-between  w-full py-2 px-1 ${currentPage == 'chat' ? mobileChatClasses : ''} xhidden lg:hidden`}>
                <div className="w-30 ml-1 ">
                    <NavLogo />
                </div>

                <div className="flex flex-grow  justify-end">
                    <div className="flex flex-grow justify-between flex-col ">
                        <div className="flex flex-row flex-grow justify-around items-center gap-x-1.3 md:gap-x-2   ">
                            {[navigationObjects[0], navigationObjects[1], mobileNavBlueEnvelopeProgramPage].map((item) => {
                                let cls = `flex flex-col items-center relative text-xs ${item.className} ${item.active ? 'accent-text-color active-menu-tab font-extrabold' : 'text-primary-gray-900 font-semibold'}`;
                                return (
                                    <a key={item.name} href={item.href} className={cls} id={`mobile-${item.id}`}
                                        onClick={(e) => {
                                            if (item.name.toLowerCase() === 'chat' && loggedInUser === null) {
                                                e.preventDefault();
                                                toggleLoginAlertModalModal();
                                            }

                                            if (item.id.toLowerCase() === 'menu-link-ai-chat' && loggedInUser === null) {
                                                e.preventDefault();
                                                toggleLoginAlertModalModal();
                                            }

                                            if (item.id.toLowerCase() === 'menu-link-cb' && loggedInUser === null) {
                                                e.preventDefault();
                                                toggleLoginAlertModalModal();
                                            }

                                            if (item.id.toLowerCase() === 'menu-link-blue-envelope-program' && loggedInUser === null) {
                                                e.preventDefault();
                                                toggleLoginAlertModalModal();
                                            }
                                        }}
                                    >
                                        {item.icon &&
                                            <span className="relative">
                                                {React.createElement(item.icon)}
                                                {item?.budgeCount > 0 &&
                                                    <span className={`bg-red-600 max-h-[15px] flex items-center absolute p-1 text-white  rounded-full  -right-[8px]  ${item.active ? '-top-[5px]' : '-top-[5px]'}`} style={{ fontSize: "10px" }} >
                                                        {item?.budgeCount}
                                                    </span>
                                                }
                                            </span>
                                        }
                                        <span className="whitespace-nowrap text-[10px] md:text-xs">
                                            {/* {item.name.toLowerCase().indexOf('blue') >= 0 ? 'Blue Envelope' : item.name} */}
                                            {item.name}
                                        </span>
                                    </a>
                                )
                            })}

                            <button id="menu-btn-mobile-search" onClick={toggleMobileSearchModalModal} className="p-0 md:p-2 m-0">
                                <MagnifyingGlassIcon className="h-6 w-6 md:h-4 md:w-4" aria-hidden="true" />
                                <span className="sr-only">open search form</span>
                            </button>
                            <MobileMenuSearchModal isOpen={isMobileSearchModalOpen} closeFun={setIsMobileSearchModalOpen} />
                        </div>

                        {/* second line has been hidden temporarily */}
                        <div className="flex flex-row flex-grow justify-around items-center gap-x-1.3 md:gap-x-2 hidden  ">
                            {[navigationObjects[2], navigationObjects[3], navigationObjects[4]].map((item) => {
                                let cls = `flex flex-col items-center relative text-xs ${item.className} ${item.active ? 'accent-text-color active-menu-tab font-extrabold' : 'text-primary-gray-900 font-semibold'}`;
                                return (
                                    <a key={item.name} href={item.href} className={cls} id={`mobile-${item.id}`}
                                        onClick={(e) => {
                                            if (item.name.toLowerCase() === 'chat' && loggedInUser === null) {
                                                e.preventDefault();
                                                toggleLoginAlertModalModal();
                                            }

                                            // Ask Wefayo AI: show login alert if not logged in
                                            if (item.id.toLowerCase() === 'menu-link-ai-chat' && loggedInUser === null) {
                                                e.preventDefault();
                                                toggleLoginAlertModalModal();
                                            }

                                            // Communication Tools: show login alert if not logged in
                                            if (item.id.toLowerCase() === 'menu-link-cb' && loggedInUser === null) {
                                                e.preventDefault();
                                                toggleLoginAlertModalModal();
                                            }

                                            if (item.id.toLowerCase() === 'menu-link-blue-envelope-program') {
                                                e.preventDefault();
                                                toggleBlueEnvelopeProgram();
                                            }
                                        }}
                                    >
                                        {item.icon &&
                                            <span className="relative">
                                                {React.createElement(item.icon)}
                                                {item?.budgeCount > 0 &&
                                                    <span className={`bg-red-600 max-h-[15px] flex items-center absolute p-1 text-white  rounded-full  -right-[8px]  ${item.active ? '-top-[5px]' : '-top-[5px]'}`} style={{ fontSize: "10px" }} >
                                                        {item?.budgeCount}
                                                    </span>
                                                }
                                            </span>
                                        }
                                        <span className="whitespace-nowrap text-[10px] md:text-xs">
                                            {item.name}
                                        </span>
                                    </a>
                                )
                            })}
                        </div>

                    </div>



                    {/*  This is the hamburger menu button for the mobile menu */}
                    <button role="button"
                        type="button"
                        className="-m-2.5 flex items-center justify-center rounded-md p-2.5 text-primary-gray-700"
                        onClick={handleClickMobileMenuHamburger}
                        id="menu-btn-mobile-menu-hamburger"
                    >
                        <span className="sr-only">Open main menu</span>
                        {mobileMenuOpen &&
                            <XMarkIcon aria-hidden="true" />
                        }
                        {!mobileMenuOpen &&
                            <Bars3Icon aria-hidden="true" />
                        }
                    </button> 

                </div>
            </div>

            {/* This is going to be the mobile menu, this is paused for now */}
            <div className={`-mr-1 flex justify-between  w-full ${currentPage == 'chat' ? mobileChatClasses : ''} hidden new-double-line-menu md:hidden`}>
                {/* implement a grid of two rows and four columns */}
                <div className="grid grid-cols-5 grid-rows-2 bg-red-500 w-full">
                    <div className="col-span-1 row-span-1 bg-blue-200">
                        <div className="bg-yellow-500 p-1">
                            <NavLogo />
                        </div>
                    </div>
                    <div className="col-span-1 row-span-1 bg-blue-300">
                        r1c2
                    </div>
                    <div className="col-span-1 row-span-1 bg-blue-400">
                        r1c3
                    </div>
                    <div className="col-span-1 row-span-1 bg-blue-500">
                        r1c4
                    </div>
                    <div className="col-span-1 row-span-1 bg-green-500">
                        r1c5
                    </div>
                    <div className="col-span-1 row-span-2 bg-blue-600">
                        r2c1
                    </div>
                    <div className="col-span-1 row-span-2 bg-blue-700  ">
                        r2c2
                    </div>
                    <div className="col-span-1 row-span-2 bg-blue-800">
                        r2c3
                    </div>
                    <div className="col-span-1 row-span-2 bg-blue-900">
                        r2c4
                    </div>
                    <div className="col-span-1 row-span-2 bg-green-600">
                        r2c5
                    </div>
                </div>
            </div>


            <Dialog as="div" className="lg:hidden " open={mobileMenuOpen} onClose={() => closeMobileMenu()}>
                <div className="fixed inset-0 z-10 bg-gray-900/60" />
                <Dialog.Panel className="fixed top-[48px] inset-y-0 right-0 z-10 w-full overflow-y-none  h-fit max-h-[calc(100vh-48px)] bg-primary-white shadow-lg sm:max-w-sm sm:ring-1 sm:ring-primary-gray-900/10">
                    <div className=" flow-root">
                        <div className="-my-1 divide-y divide-primary-gray-500/10 mobile ">
                            <div className="flex flex-col max-h-[calc(100vh-48px)] overflow-y-auto py-1 ">

                                {openMenuContext === "header" &&
                                    <div className="flex flex-col h-fit w-full px-6 py-2 gap-y-2 ">


                                        {loggedInUser != null &&
                                            <div className="relative inline-block text-left">
                                                <div>
                                                    <div className="inline-flex flex flex-col items-center w-full justify-center rounded-sm bg-primary-white text-sm font-semibold text-gray-900 shadow-xs xring-1 ring-inset ring-gray-200 hover:bg-orange-50">
                                                        <NavUserAvatar user={loggedInUser} />
                                                        <div className='mx-2'>
                                                            <div>
                                                                <p className="text-sm font-bold text-gray-700 group-hover:text-gray-900">
                                                                    <a href="/profile">{loggedInUser.username} (My Profile)</a>
                                                                </p>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        }

                                        {/* mobile slide out menu items */}
                                        {[navigationObjects[2], ...navigationObjects.slice(3), mobileNavObjActivitiesPage].map((item) => {
                                            let cls = `flex flex-row items-center gap-x-2 text-sm leading-6 ${item.active ? 'accent-text-color active-menu-tab font-extrabold' : 'text-primary-gray-900 font-semibold mt-0 '}`;

                                            return (
                                                <a key={item.name} href={item.href} className={cls} id={item.id}
                                                    onClick={(e) => {
                                                        if (item.name.toLowerCase() === 'chat' && loggedInUser === null) {
                                                            e.preventDefault();
                                                            e.stopPropagation();
                                                            toggleLoginAlertModalModal();
                                                            return false;
                                                        }

                                                        if (item.id.toLowerCase() === 'menu-link-cb' && loggedInUser === null) {
                                                            e.preventDefault();
                                                            toggleLoginAlertModalModal();
                                                            return false;
                                                        }
                                                    }}
                                                    style={{ paddingTop: "5px", paddingBottom: "5px" }}
                                                >
                                                    {item.icon &&
                                                        <span className="relative">
                                                            {React.createElement(item.icon)}
                                                            {item?.budgeCount > 0 &&
                                                                <span className={`bg-red-600 max-h-[15px] flex items-center absolute p-1 text-white  rounded-full  -right-[8px]  ${item.active ? '-top-[5px]' : '-top-2'}`} style={{ fontSize: "10px" }} >
                                                                    {item?.budgeCount}
                                                                </span>
                                                            }
                                                        </span>
                                                    }
                                                    <span>
                                                        {item.name}
                                                    </span>
                                                </a>
                                            )
                                        })}



                                        {/* <button role="button" 
                                    onClick={loggedInUser !== null ? toggleSelectForumModal : goToLogin}
                                    className={`text-sm leading-6 text-left mt-5 ${currentPage == "addpost" ? "accent-text-color active-menu-tab font-extrabold" : "text-primary-gray-900 font-semibold"}`}
                                >
                                    Add Post
                                </button> */}

                                        {/* <button role="button"
                                            onClick={(e) => {
                                                e.preventDefault();
                                                e.stopPropagation();
                                                if (loggedInUser !== null) {
                                                    toggleInviteUserModal();
                                                } else {
                                                    goToLogin();
                                                }
                                            }}
                                            className="flex flex-row items-center gap-x-2 text-sm leading-6 text-left text-primary-gray-900 font-bold "
                                            id="menu-btn-invite"
                                            style={{ paddingTop: "5px", paddingBottom: "5px" }}
                                        >

                                            <span className="relative">
                                                <EnvelopeOpen />
                                            </span>
                                            <span>
                                                Invite
                                            </span>
                                        </button> */}

                                        <br />

                                        {loggedInUser == null &&
                                            <div className="flex items-center justify-between gap-x-6 ">

                                                <a href="/login" id="menu-link-login" className="rounded-sm bg-purple-900 px-3 py-1 text-sm font-semibold text-primary-white shadow-sm hover:bg-purple-800 ">
                                                    Log In
                                                </a>
                                                <a
                                                    href="/register"
                                                    id="menu-link-signup"
                                                    className="rounded-sm bg-purple-900 px-3 py-1 text-sm font-semibold text-primary-white shadow-sm hover:bg-purple-800 "
                                                >
                                                    Sign Up
                                                </a>

                                            </div>
                                        }

                                        {loggedInUser != null &&
                                            <>
                                                {/* <a
                                            href={`/profile/${loggedInUser._id}`}
                                            className={classNames(
                                                currentPage === 'profile' ? 'accent-text-color active-menu-tab font-extrabold ' : 'text-primary-gray-900',
                                                'block py-2 text-sm leading-6 hover:bg-orange-50  font-semibold'
                                            )}
                                            id="menu-link-user-profile"
                                            style={{paddingTop: "5px", paddingBottom: "5px"}}
                                        >
                                            My Profile
                                        </a> */}

                                                <a
                                                    href="/community-request-form"
                                                    className={classNames(
                                                        currentPage === 'notifications' ? 'accent-text-color active-menu-tab font-extrabold ' : 'text-primary-gray-900',
                                                        'block py-2 text-sm leading-6 hover:bg-orange-50  font-semibold'
                                                    )}
                                                    id="menu-link-community-requests"
                                                    style={{ paddingTop: "5px", paddingBottom: "5px" }}
                                                >
                                                    Community Requests
                                                </a>

                                                <a
                                                    href="/profile/password"
                                                    className={classNames(
                                                        currentPage === 'password' ? 'accent-text-color active-menu-tab font-extrabold ' : 'text-primary-gray-900',
                                                        'block py-2 text-sm leading-6 hover:bg-orange-50  font-semibold'
                                                    )}
                                                    id="menu-link-update-password"
                                                    style={{ paddingTop: "5px", paddingBottom: "5px" }}
                                                >
                                                    Update Password
                                                </a>

                                                <a
                                                    href="/support"
                                                    className={classNames(
                                                        currentPage === 'support' ? 'accent-text-color active-menu-tab font-extrabold' : 'text-primary-gray-900',
                                                        'block py-2 text-sm leading-6 hover:bg-orange-50  font-semibold relative'
                                                    )}
                                                    id="menu-link-support"
                                                    style={{ paddingTop: "5px", paddingBottom: "5px" }}
                                                >
                                                    Support
                                                    {supportBudgeCount > 0 &&
                                                        <span className="bg-red-600 max-h-[15px] flex items-center absolute p-1 text-white rounded-full right-2 top-1" style={{ fontSize: "10px" }}>
                                                            {supportBudgeCount}
                                                        </span>
                                                    }
                                                </a>

                                                <div className="py-0">
                                                    <form method="POST" action="#" onSubmit={handleSubmit}>
                                                        <div>
                                                            <button role="button"
                                                                id="menu-btn-sign-out"
                                                                type="submit"
                                                                className="block w-full flex gap-x-1 items-center py-2 text-left text-sm font-bold hover:bg-red-100 hover:text-red-900"
                                                            >
                                                                <PowerIcon aria-hidden="true" />
                                                                Sign Out
                                                            </button>
                                                        </div>
                                                    </form>
                                                </div>
                                            </>
                                        }

                                    </div>
                                }

                                <br />

                                {/* communities list */}
                                {openMenuContext === "page-body" &&
                                    <AsideCommunities
                                        communities={communities}
                                        handleClickRequestCommunity={handleClickRequestCommunity}
                                        onSelectCommunity={(community) => { setMobileMenuOpen(false); onSelectCommunity(community) }}
                                        selectedCommunityId={selectedCommunityId}
                                        loggedInUser={loggedInUser}
                                        context={'header'}
                                        hideMobileMenu={() => closeMobileMenu()}
                                        setCurrentCommunity={setCurrentCommunity}
                                        currentPage={currentPage}
                                        communityBudges={communityBudgesMap}
                                    />
                                }
                            </div>
                        </div>
                    </div>
                </Dialog.Panel>
            </Dialog>
        </header>
    )
}

export default NavHeader;
